import { NgModule } from '@angular/core';
import { SharedApiKno2fyMainModule } from '@kno2/shared/data-access/api-kno2fy-main';

@NgModule({
    imports: [SharedApiKno2fyMainModule]
})
export class DesktopDataAccessApiDesktopModule {}
